<template>
  <div class="api-meta-item">
    <dt class="api-meta-item__label">
      {{ label }}
    </dt>
    <dd class="api-meta-item__value">
      <slot>{{ value }}</slot>
    </dd>
  </div>
</template>

<script setup lang="ts">
const { label, value = '' } = defineProps<{
  label: string;
  value?: string;
}>();
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-meta-item {
  @apply flex flex-col gap-4 min-w-0;
}

.api-meta-item__label {
  @apply text-sm text-neutral-text-weak;
}

.api-meta-item__value {
  @apply text-base text-neutral-text-strong m-0 truncate;
}
</style>
